import * as React from 'react';
import * as Sentry from '@sentry/react';
import { createBrowserRouter, Outlet } from 'react-router-dom';
import RouteWrapper from './route-wrapper';
import { baseRoute } from 'src/helpers/base-route.helper';
import ErrorFallback from 'src/components/AppError';
import logger from 'src/logger';

const Dashboard = React.lazy(() => import('./dashboard'));
const Builder = React.lazy(() => import('./builder'));
const OnBoarding = React.lazy(() => import('./onboarding'));
const TemplatePreview = React.lazy(() => import('./template-preview'));
const NoAuthOnboarding = React.lazy(() => import('./no-auth-onboarding'));

// can remove this
const logError = (error: Error, componentStack: string, eventId: string) => {
  logger.reportError(error, { message: 'Error in error boundary', eventId, componentStack });
};
/**
 *
 * Note: React router uses an own error boundary for errors thrown in route components and loaders, so an error boundary at the top of the render tree (parent of router) won't catch errors that happen in a child of a route component. Due to this we can not add an error boundary at the top of the render tree.
 */
const ErrorBoundaryLayout = () => (
  /** Reference: https://docs.sentry.io/platforms/javascript/guides/react/features/error-boundary/ */
  <Sentry.ErrorBoundary fallback={<ErrorFallback />} onError={logError}>
    <Outlet />
  </Sentry.ErrorBoundary>
);

const router = createBrowserRouter(
  [
    {
      element: <ErrorBoundaryLayout />,
      children: [
        /**
         * Dashboard homepage
         */
        {
          path: '/',
          element: (
            <RouteWrapper>
              <Dashboard />
            </RouteWrapper>
          ),
        },

        /**
         * Site builder
         */
        {
          path: '/edit',
          //to avoid running the session logic
          element: (
            <RouteWrapper>
              <Builder />
            </RouteWrapper>
          ),
        },

        /**
         * Preview templates with dummy/default data
         */
        {
          path: '/preview-template',
          element: (
            <RouteWrapper>
              <TemplatePreview />
            </RouteWrapper>
          ),
        },

        /**
         * Manual onboarding
         */
        {
          path: '/onboard',
          element: (
            <RouteWrapper>
              <OnBoarding />
            </RouteWrapper>
          ),
        },
        {
          path: '/noAuth/onboarding',
          element: (
            <RouteWrapper>
              <NoAuthOnboarding />
            </RouteWrapper>
          ),
        },
      ],
    },
  ],
  {
    basename: baseRoute(),
  },
);

export default router;
